export default "__VITE_ASSET__B2Pj2_nm__"